module.exports = __webpack_public_path__ + "static/media/nato.0ade7442.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/nato.svg
// module id = 1313
// module chunks = 0